import { IStoreProps } from '../index';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

interface IEmptyCart {
    storeProps: IStoreProps;
}

const EmptyCart = (props: IEmptyCart) => {

    const { storeProps } = props;
    const { rootActions, useAppDispatch } = storeProps;

    const dispatch = useAppDispatch();

    const continueShopping = () => {
        dispatch(
            rootActions.main({
                isOpened: false,
                showNewUserPopup: false,
                isLoading: true,
            })
        );

        sendGAEvent('Top Mini Cart', 'Continue Shopping');
    };

    return (
        <div className="text-center">
            <p className="my-4 text-xl">Your cart is empty</p>

            <p className="mb-4 flex justify-center">
                <button
                    className="w-btn w-auto"
                    type="button"
                    onClick={ continueShopping }>Continue Shopping</button>
            </p>

            <p className="my-4 text-sm">
                <a href="/cart"
                   onClick={ () => {
                       sendGAEvent('Top Mini Cart', 'View Cart');
                   }}>View Cart</a>
            </p>
        </div>
    )
};

export default EmptyCart;